/* istanbul ignore file */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { FinalizedLTI1p3Provider } from './FinalizedLTI1p3Provider';
import { NonFinalizedLTI1p3Provider } from './NonFinalizedLTI1p3Provider';
const LTI1p3ProviderParser = 
/* #__PURE__ */ /* #__PURE__ */ codecOneOf([
    NonFinalizedLTI1p3Provider,
    FinalizedLTI1p3Provider,
]);
export const LTI1p3Provider = LTI1p3ProviderParser;
